<div class="d-flex position-relative " [ngClass]="actualClass">
  <div class="d-flex w-100">
    <div class="inline-padding" *ngIf="inputFieldValue && readonly$ | async">{{inputFieldValue |
      qPointDateFormat:QPointDateFormat.ShortDate}} - {{inputFieldValue | qPointDateFormat:QPointDateFormat.ShortTime}}
    </div>
    <qpoint-datetime-picker *ngIf="!(readonly$ | async)" [(ngModel)]="inputFieldValue" [disabled]="isDisabled"
      (ngModelChange)="inputFieldValueChange($event)">

    </qpoint-datetime-picker>

    <ng-container *ngIf="!(readonly$ | async)">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </ng-container>

  </div>

  <div class="staticIconWrapper" *ngIf="loadingIndicator">
    <qpoint-icon [pulse]="true" icon="spinner" (click)="toggleReadOnly()"></qpoint-icon>
  </div>
  <div class="staticIconWrapper" *ngIf="(readonly$ | async) && !loadingIndicator">
    <qpoint-icon icon="pencil-alt" (click)="toggleReadOnly()"></qpoint-icon>
  </div>

</div>
<qpoint-validation-message [controlToValidate]="controlForValidation"
  [isSubmitted]="controlForValidationDisplayActive"></qpoint-validation-message>
<div class="d-flex infoMessageOnEdit"
  *ngIf="(activeInlineEditingInternal$ | async) && !(readonly$ | async)  && infoMessageOnEdit">
  <div class="inlineEditingTextIcon">
    <qpoint-icon iconType="material-outlined" icon="info"></qpoint-icon>
  </div>
  <div>
    <span [innerHTML]="infoMessageOnEdit | translate"></span>
  </div>
</div>

<div class="d-flex flex-row justify-content-end" style="margin-top: 5px;"
  *ngIf="!(readonly$ | async)  && (activeInlineEditingInternal$ | async)">
  <div class="d-flex">
    <qpoint-button icon="times" [variant]="'icon'" (buttonClicked)="setToReadonly()">

    </qpoint-button>
  </div>
  <div class="d-flex">
    <qpoint-button [variant]="'icon'" icon="check" (buttonClicked)="writeIdentifierInForm()"></qpoint-button>
  </div>
</div>